export default "__VITE_ASSET__DR$3vrr4__"